import type { FaireProductEntity } from "../../entity_types/product";

export const p_dyb22jzkrz: FaireProductEntity = {
  token: "p_dyb22jzkrz",
  type: "product",
  name: "Gulf Breeze Goat Milk Soap",
  brandName: "Gulf Kind",
  imageUrl:
    "https://cdn.faire.com/fastly/e5ae58df95c1dbbdeb6b308bd275aabb529938f74759eaeffd80797dc8c4b594.png",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/581eb0f3dfb01d0bbd1470dc17afadbb72ad3f7385bc82e088511408ab6fc841.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
